export const GET_FEEDS_REQUEST = "GET_POSTS_REQUEST";
export const GET_PROFILE_FEEDS = "GET_PROFILE_FEEDS";
export const GET_FEEDS_POSTS = "GET_FEEDS_POSTS";
export const GET_MORE_FEEDS_POSTS = "GET_MORE_FEEDS_POSTS";
export const POST_FEED_POST = "POST_FEED_POST";
export const TAG_FEED_POST = "TAG_FEED_POST";
export const POST_FEED_COMMENT = "POST_FEED_COMMENT";
export const POST_FEED_LIKE = "POST_FEED_LIKE";
export const POST_FEED_COMMENT_TEXT = "POST_FEED_COMMENT_TEXT"
export const DELETE_FEED_POST = "DELETE_FEED_POST";
export const POST_SEARCH_TAGS = "POST_SEARCH_TAGS";
export const REMOVE_FEED_COMMENT = "REMOVE_FEED_COMMENT";
export const EDIT_POST = "EDIT_POST";
export const INSTRUCTOR_SEARCH_INTERNSHIP = "INSTRUCTOR_SEARCH_INTERNSHIP";
export const INSTRUCTOR_GET_ALL_INTERNSHIP = "INSTRUCTOR_GET_ALL_INTERNSHIP";
export const APPLY_INTERNSHIP = "APPLY_INTERNSHIP";
export const PUBLIC_INTERNSHIP_SEARCH = "PUBLIC_INTERNSHIP_SEARCH";
export const FEED_SEARCH_INTERNSHIP_TAGS = "FEED_SEARCH_INTERNSHIP_TAGS";
export const FEED_INTERNSHIP_FILTER_BY_TAGS = "FEED_INTERNSHIP_FILTER_BY_TAGS";
export const FEED_INTERNSHIP_FILTER_BY_LOCATION = "FEED_INTERNSHIP_FILTER_BY_LOCATION";
export const FEED_INTERNSHIP_FILTER_BY_WORKTYPE = "FEED_INTERNSHIP_FILTER_BY_WORKTYPE";
export const FEED_INTERNSHIP_FILTER_BY_STATUS = "FEED_INTERNSHIP_FILTER_BY_STATUS";
export const FEED_INTERNSHIP_FILTER_BY_CLASS = "FEED_INTERNSHIP_FILTER_BY_CLASS";
export const INTERNSHIP_SAVE_PRIVATE_INTERNSHIP = "INTERNSHIP_SAVE_PRIVATE_INTERNSHIP";